import curry from "../../../../lib/core/functional/curry";
import thunk from "../../../../lib/core/functional/thunk";
import loadExternalScript from "../../../../utils/loadExternalScript.js";

let IS_CAPTCHA_READY = false;
const CAPTCHA_WAITERS = [];

const submitCaptcha = thunk(function submitCaptcha(siteKey) {
    return grecaptcha.execute(siteKey, { action: "submit" });
});

function triggerCallback(cb) {
    cb();
}

function onCatpchaReady() {
    IS_CAPTCHA_READY = true;
    CAPTCHA_WAITERS.forEach(triggerCallback);
    CAPTCHA_WAITERS.length = 0;
}

function onCatpchaLoaded() {
    if (!("grecaptcha" in window)) {
        setTimeout(onCatpchaLoaded, 30);
    }

    window.grecaptcha.ready(onCatpchaReady);
}

function addToCaptchaWaiter(resolve) {
    CAPTCHA_WAITERS.push(resolve);
}

function waitForCaptcha() {
    if (IS_CAPTCHA_READY) {
        return Promise.resolve();
    } else {
        return new Promise(addToCaptchaWaiter);
    }
}

const appendCatpchaResultToBody = curry(function appendCatpchaResultToBody(siteKey, body) {
    function onToken(token) {
        return { ...body, ["g-recaptcha-response"]: token };
    }

    return waitForCaptcha().then(submitCaptcha(siteKey)).then(onToken);
});

function loadReCaptcha(siteKey) {
    const url = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    loadExternalScript(url, onCatpchaLoaded);
}

export default function makeRecaptchaBlocker(siteKey) {
    loadReCaptcha(siteKey);

    return {
        secureRequest: appendCatpchaResultToBody(siteKey),
    };
}
